import {defineStore} from "pinia";
import {type RemovableRef, useStorage} from "@vueuse/core";
import {ScreenSize} from "@/constants/screen-size-helper";

export const LaptopWidth: number = 1024;
export const MobileWidth: number = 768;

interface IThemeState {
    collapsedSideMenu: RemovableRef<boolean>;
    screenSize: ScreenSize
    drawerWidth: string;
    modalWidth: string;
}

export const useThemeStore = defineStore({
    id: 'theme',
    state: () => ({
        collapsedSideMenu: useStorage('navigationCollapsed', false),
        screenSize: ScreenSize.Default,
        drawerWidth: '35%',
        modalWidth: '25%',
    } as IThemeState),
    getters: {},

    actions: {
        collapse() {
            this.collapsedSideMenu = true;
        },
        expand() {
            this.collapsedSideMenu = false;
        },
        determineSize(size: number) {
            if (size <= MobileWidth) {
                this.screenSize = ScreenSize.Mobile;
                this.drawerWidth = '100%';
                return;
            }

            if (size <= LaptopWidth) {
                this.screenSize = ScreenSize.Laptop;
                this.drawerWidth = '75%';
                return;
            }

            this.screenSize = ScreenSize.Default;
            this.drawerWidth = '35%';
        }
    },
});
